var React = require('react');

function Loop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.9776 22.667C17.9358 22.667 21.9552 18.4883 21.9552 13.3335C21.9552 8.17875 17.9358 4 12.9776 4C8.01941 4 4 8.17875 4 13.3335C4 18.4883 8.01941 22.667 12.9776 22.667Z","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M24.198 24.9999L19.3164 19.9248","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Loop.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Loop;

Loop.default = Loop;
